module.exports = __webpack_public_path__ + "img/sneaker-gear-bg.0a6798f1.png";